import React from "react";
import { Link } from "react-router-dom";
import { Feather, ArrowRight, BookOpen, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <div className="animate-fade-up max-w-4xl" data-testid="page-about">
      {/* header */}
      <div className="mb-10">
        <h1 className="font-display text-4xl lg:text-5xl text-paper mt-3 leading-tight">
          About Majalisul Ilm
        </h1>
        <div className="mt-4 flex items-baseline gap-3">
          <span className="font-arabic text-gold text-2xl leading-none">مجالس العلم</span>
          <span className="italic text-white/60 text-lg">Circles of Knowledge</span>
        </div>
      </div>

      {/* theme quote card */}
      <section className="archival-card featured rounded-lg p-8 lg:p-10 relative overflow-hidden mb-12" data-testid="about-theme">
        <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-gold/[0.06] blur-3xl" />
        <div className="relative">
          <Feather className="w-5 h-5 text-gold mb-4" />
          <p className="font-display text-2xl lg:text-3xl italic text-paper leading-snug">
            &ldquo;Understanding Islam by studying the classical works of As-Salaf As-Saleh
            from the scholars of present.&rdquo;
          </p>
          <div className="hair-divider mt-8" />
          <p className="label-caps text-gold/85 mt-4">The Theme of this Archive</p>
        </div>
      </section>

      {/* main body */}
      <section className="space-y-6 text-white/80 text-[17px] leading-[1.75]" data-testid="about-body">
        <p>
          Assalaamu Alaikum wa rahmatullahi wa barakatuhu. This site is dedicated to learning
          the deen by studying the classical works of early scholars from the righteous
          predecessors <span className="italic text-gold">(Salaf-as-saleh)</span>.
        </p>
        <p>
          May Allah help us in understanding the correct manhaj and aqeedah and keep us
          steadfast on it till death. <span className="italic text-emerald-soft">Aameen!</span>
        </p>
      </section>

      {/* what we cover */}
      <section className="mt-14">
        <p className="label-caps text-gold/85">What you will find here</p>
        <h2 className="font-display text-2xl text-paper mt-1 mb-6">Our approach to knowledge</h2>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="archival-card rounded-lg p-6">
            <BookOpen className="w-5 h-5 text-emerald-soft mb-3" />
            <h3 className="font-display text-xl text-paper mb-2">Classical Works</h3>
            <p className="text-sm text-white/65 leading-relaxed">
              Full studies of foundational treatises — Usool ath Thalathah, Qawaaid al Arbaa,
              Hiliyat Taalibul Ilm, and the sayings of the Salaf — taught by contemporary
              scholars grounded in the Sunnah.
            </p>
          </div>
          <div className="archival-card rounded-lg p-6">
            <ShieldCheck className="w-5 h-5 text-gold mb-3" />
            <h3 className="font-display text-xl text-paper mb-2">Manhaj of the Salaf</h3>
            <p className="text-sm text-white/65 leading-relaxed">
              Every lecture is transmitted with the understanding of the earliest generations
              — Sahaba, Taabi&rsquo;een and their followers — as safeguarded by the scholars
              of Ahlus Sunnah in every age.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="mt-14 mb-6">
        <div className="hair-divider mb-8" />
        <div className="flex flex-wrap items-center justify-between gap-4">
          <p className="font-display text-lg text-paper">
            Begin your listening from the current live series.
          </p>
          <div className="flex gap-3">
            <Link to="/collections" className="btn-ghost-gold inline-flex items-center gap-2" data-testid="about-cta-collections">
              Browse collections
            </Link>
            <Link to="/explore" className="btn-primary inline-flex items-center gap-2" data-testid="about-cta-explore">
              Explore lectures <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
